import { getIPVersion } from 'routes/SnmpDestination/utils/snmpDestList.adapter';
import { SnmpDestination, SnmpDestinationUI, SnmpV3User } from './snmp.types';

// eslint-disable-next-line import/prefer-default-export
export function adaptSnmpUserToCreate(snmpUser: SnmpV3User): SnmpV3User {
  return snmpUser;
}

// eslint-disable-next-line import/prefer-default-export
export function adaptSnmpDestPayload(
  formValues: SnmpDestinationUI
): SnmpDestination {
  const ret: SnmpDestination = {
    id: formValues.id,
    DESTID: formValues.DESTID ?? '',
    NAME: formValues.NAME,
    VERSION: formValues.VERSION,
    SECURITYNAME:
      formValues.VERSION === 'SNMPV3'
        ? formValues.SECURITYNAMEV3
        : formValues.SECURITYNAMEV3,
    DESTIP: formValues.DESTIP,
    DESTPORT: formValues.DESTPORT,
    OWNPORT: formValues.OWNPORT,
    REQSTATE: formValues.REQSTATE
  };

  const ipFamily = getIPVersion(formValues.DESTIP ?? '');
  if (formValues.OWNIP) {
    ret.OWNIP = formValues.OWNIP;
  } else {
    switch (ipFamily) {
      case 'IPv4': {
        ret.OWNIP = '0.0.0.0';
        break;
      }
      case 'IPv6': {
        ret.OWNIP = '::';
        break;
      }
      default: {
        break;
      }
    }
  }
  return ret;
}
